module.exports = __webpack_public_path__ + "b9d4209d41fb2e77861c1daecc72b867.svg";